import angular from 'angular';
import socialSecurityModalComponent from './socialSecurityModal.component';

let socialSecurityModalModule = angular.module('socialSecurityModal', [
])

.component('socialSecurityModal', socialSecurityModalComponent)

.name;

export default socialSecurityModalModule;



// WEBPACK FOOTER //
// ./client/app/social-security.module/components/socialSecurityModal/socialSecurityModal.js